import { Navigate } from '@sorare/routing';
import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { ANY_SPORT_SERIES_MY_CARDS_GALLERY_RARITY } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

export const GalleryPage = () => {
  const { generateSportContextPath } = useSportContext();

  return (
    <Navigate
      to={generateSportContextPath(ANY_SPORT_SERIES_MY_CARDS_GALLERY_RARITY, {
        params: {
          rarity: Rarity.common,
        },
      })}
      replace
    />
  );
};

export default GalleryPage;
